module["exports"] = [
  "#{city_prefix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/address/city.js
 ** module id = 480
 ** module chunks = 0
 **/